import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
    Typography,
    Card,
    Statistic,
    Spin,
    Button,
    Form,
    Row,
    Col,
    Flex,
    Steps,
} from "antd";

//PROJECT IMPORTS
import MainLayout from "../../../../../components/layouts/MainLayout";
import CustomButton from "../../../../../components/custom/CustomButton";
import TopContent from "../../../../../components/layouts/TopContent";
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";
import DetailForm from "./groupLoanApplicationForms/DetailForm";
import ChargesForm from "./groupLoanApplicationForms/ChargesForm";
import TermsForm from "./groupLoanApplicationForms/TermsForm";
import Preview from "./groupLoanApplicationForms/Preview";
import "../../steps.css";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import { apiConfig, labelConfig, staticConfig } from "../../../group.config";
import styles from "../../../../../assets/styles/styles";
import dayjs from "dayjs";


const GroupLoanApplication = (props) => {
    const { state } = useLocation();

    //DECLARED VARIABLES    
    const [isProductSelected, setIsProductSelected] = useState(false);
    const [isStepDisabled, setIsStepDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [showDetailsForm, setShowDetailsForm] = useState(false);
    const [groupInfo, setGroupInfo] = useState(null);
    const [chargeTableSource, setChargeTableSource] = useState([]);
    const [templateProdDetail, setTemplateProdDetail] = useState({});
    const [current, setCurrent] = useState(0);



    const { userData } = props;
    const { Text } = Typography;
    const { session } = userData;
    const navigate = useNavigate();
    const [useForm] = Form.useForm();
    // CHARGES FORM REQUIRED VARIABLES
    const [chargeTableCount, setChargeTableCount] = useState(0);

    // ENDPOINT DECLARED VARIABLES
    const [chargeOptions, setChargeOptions] = useState([]);
    const [loanCollateralOptions, setLoanCollateralOptions] = useState([]);
    const [loanAccountDetails, setLoanAccountDetails] = useState([]);
    const [accountLinkingOptions, setAccountLinkingOptions] = useState([]);
    const [productTemplate, setProductTemplate] = useState([]);
    const [penaltyTableSource, setPenaltyTableSource] = useState([]);
    const [customerDetail, setCustomerDetail] = useState([]);
    const [customerId, setCustomerId] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const [loanOfficerOptions, setLoanOfficerOptions] = useState([]);
    const [loanPurposeOptions, setLoanPurposeOptions] = useState([]);
    const [fundOptions, setFundOptions] = useState([]);
    const [termFrequencyTypeOptions, setTermFrequencyTypeOptions] = useState([]);
    const [repaymentFrequencyTypeOptions, setRepaymentFrequencyTypeOptions] = useState([]);
    const [repaymentFrequencyNthDayTypeOptions, setRepaymentFrequencyNthDayTypeOptions] = useState([]);
    const [repaymentFrequencyDaysOfWeekTypeOptions, setRepaymentFrequencyDaysOfWeekTypeOptions] = useState([]);
    const [interestTypeOptions, setInterestTypeOptions] = useState([]);
    const [amortizationTypeOptions, setAmortizationTypeOptions] = useState([]);
    const [interestCalculationPeriodTypeOptions, setInterestCalculationPeriodTypeOptions] = useState([]);
    const [disbursementDataList, setDisbursementDataList] = useState([]);

    const [transactionProcessingStrategyOptions, setTransactionProcessingStrategyOptions] = useState([]);
    const [allowPartialPeriodInterestCalcualtion, setAllowPartialPeriodInterestCalcualtion] = useState(false);
    const [isEqualAmortization, setIsEqualAmortization] = useState(false);

    // DECLARED VARIABLES FOR CHARRGES FORM
    const [chargesValue, setChargesValue] = useState(null);
    const [collateralTableSource, setCollateralTableSource] = useState([]);

    // ENDPOINT DECLARED VARIABLES
    const [formData, setFormData] = useState({
        details: null,
        terms: null,
        charges: null,
    });

    useEffect(() => {
        getProductTemplate()
    }, [])

    const getGroupTemplate = (productParam) => {

        setIsLoading(true);
        const params = {
            activeOnly: true,
            groupId: state.id,
            productId: productParam,
            staffInSelectedOfficeOnly: true,
            templateType: "group"
        };
        const url = `${apiConfig.Loans}/template`;

        let body = {
            session,
            params,
        };

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objList = res;

                setProductTemplate(objList);

                let tempLoanPurposeOptions = [];
                let tempLoanOfficerOptions = [];
                let tempFundOptions = [];
                let tempTermFrequencyTypeOptions = [];
                let tempRepaymentFrequencyTypeOptions = [];
                let tempRepaymentFrequencyNthDayTypeOptions = [];
                let tempRepaymentFrequencyDaysOfWeekTypeOptions = [];
                let tempInterestTypeOptions = [];
                let tempAmortizationTypeOptions = [];
                let tempInterestCalculationPeriodTypeOptions = [];
                let tempTransactionProcessingStrategyOptions = [];
                let tempChargeOptions = [];
                let tempLoanCollateralOptions = [];
                let tempCharges = [];
                let tempPenalty = [];
                const tempAccountLinking = [];

                objList?.fundOptions?.forEach((element) => {
                    tempFundOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.loanPurposeOptions?.forEach((element) => {
                    tempLoanPurposeOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.termFrequencyTypeOptions?.forEach((element) => {
                    tempTermFrequencyTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.repaymentFrequencyTypeOptions?.forEach((element) => {
                    tempRepaymentFrequencyTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.repaymentFrequencyNthDayTypeOptions?.forEach((element) => {
                    tempRepaymentFrequencyNthDayTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.repaymentFrequencyDaysOfWeekTypeOptions?.forEach((element) => {
                    tempRepaymentFrequencyDaysOfWeekTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.interestTypeOptions?.forEach((element) => {
                    tempInterestTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.amortizationTypeOptions?.forEach((element) => {
                    tempAmortizationTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.interestCalculationPeriodTypeOptions?.forEach((element) => {
                    tempInterestCalculationPeriodTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.transactionProcessingStrategyOptions?.forEach((element) => {
                    tempTransactionProcessingStrategyOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.chargeOptions?.forEach((element) => {
                    tempChargeOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });


                objList?.charges?.forEach((element, index) => {
                    tempCharges.push({
                        key: index + 1,
                        id: element?.chargeId ? element?.chargeId : "-",
                        name: element?.name ? element?.name : "-",
                        type: element?.chargeCalculationType?.value
                            ? element?.chargeCalculationType?.value
                            : "-",
                        amount: element?.amount ? (
                            <Statistic
                                value={element?.amount}
                                precision={2}
                                valueStyle={{ fontSize: "16px" }}
                            />
                        ) : (
                            0
                        ),
                        amountToUse: element.amount ? element.amount : 0,
                        collectedOn: element?.chargeTimeType?.value
                            ? element?.chargeTimeType?.value
                            : "-",
                        feeOnMonthDay: element?.feeOnMonthDay
                            ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
                            : "-",
                        feeInterval: element?.feeInterval?.value
                            ? element?.feeInterval?.value
                            : "-",
                    });
                });

                objList?.overdueCharges?.forEach((element, index) => {
                    tempPenalty.push({
                        key: index + 1,
                        id: element?.chargeId ? element?.chargeId : "-",
                        name: element?.name ? element?.name : "-",
                        type: element?.chargeCalculationType?.value
                            ? element?.chargeCalculationType?.value
                            : "-",
                        amount: element?.amount ? (
                            <Statistic
                                value={element?.amount}
                                precision={2}
                                valueStyle={{ fontSize: "16px" }}
                            />
                        ) : (
                            0
                        ),
                        collectedOn: element?.chargeTimeType?.value
                            ? element?.chargeTimeType?.value
                            : "-",
                    });
                });

                objList?.loanCollateralOptions?.forEach((element) => {
                    tempLoanCollateralOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.accountLinkingOptions?.forEach((element) => {
                    tempAccountLinking.push({
                        value: element.id,
                        label: element.productName,
                    });
                });

                objList?.loanOfficerOptions?.forEach((element) => {
                    tempLoanOfficerOptions.push({
                        value: element.id,
                        label: element.displayName,
                    });
                });

                setLoanAccountDetails(objList);
                setLoanOfficerOptions(tempLoanOfficerOptions);
                setLoanPurposeOptions(tempLoanPurposeOptions);
                setFundOptions(tempFundOptions);
                setTermFrequencyTypeOptions(tempTermFrequencyTypeOptions);
                setRepaymentFrequencyTypeOptions(tempRepaymentFrequencyTypeOptions);
                setRepaymentFrequencyNthDayTypeOptions(
                    tempRepaymentFrequencyNthDayTypeOptions
                );
                setRepaymentFrequencyDaysOfWeekTypeOptions(
                    tempRepaymentFrequencyDaysOfWeekTypeOptions
                );
                setInterestTypeOptions(tempInterestTypeOptions);
                setAmortizationTypeOptions(tempAmortizationTypeOptions);
                setInterestCalculationPeriodTypeOptions(
                    tempInterestCalculationPeriodTypeOptions
                );
                setTransactionProcessingStrategyOptions(
                    tempTransactionProcessingStrategyOptions
                );
                setChargeOptions(tempChargeOptions);
                setLoanCollateralOptions(tempLoanCollateralOptions);
                setAccountLinkingOptions(tempAccountLinking);
                setChargeTableSource(tempCharges);
                setPenaltyTableSource(tempPenalty);

                useForm.setFieldsValue({
                    principal: objList?.principal,
                    fundId: objList?.fundId,
                    loanTermFrequency: objList?.termFrequency,
                    repaymentEvery: objList?.repaymentEvery,
                    numberOfRepayments: objList?.numberOfRepayments,
                    interestRatePerPeriod: objList?.interestRatePerPeriod,
                    interestType: objList?.interestType?.id,
                    repaymentFrequencyType: objList?.repaymentFrequencyType?.id,
                    loanTermFrequencyType: objList?.termPeriodFrequencyType?.id,
                    amortizationType: objList?.amortizationType?.id,
                    interestCalculationPeriodType:
                        objList?.interestCalculationPeriodType?.id,
                    transactionProcessingStrategyId:
                        objList?.transactionProcessingStrategyId,
                    maxOutstandingLoanBalance: objList?.maxOutstandingLoanBalance,
                    daysInMonth: objList?.daysInMonthType?.value,
                    daysinYear: objList?.daysInYearType?.value,
                    interestRecalculationCompounding:
                        objList?.interestRecalculationData
                            ?.interestRecalculationCompoundingType?.value,
                    FrequencyForRecalculate:
                        objList?.interestRecalculationData?.recalculationRestFrequencyType
                            ?.value,
                    advancePayments:
                        objList?.interestRecalculationData?.rescheduleStrategyType?.value,
                    isInterestRecalculationEnabled:
                        objList?.isInterestRecalculationEnabled,
                    recalculationCompoundingFrequency:
                        objList?.interestRecalculationData
                            ?.recalculationCompoundingFrequencyType?.value,
                    inArrearsTolerance: objList?.inArrearsTolerance,
                    allowPartialPeriodInterestCalcualtion:
                        objList?.allowPartialPeriodInterestCalcualtion,
                    isEqualAmortization: objList?.isEqualAmortization,
                    graceOnInterestCharged: objList?.graceOnInterestCharged,
                    graceOnPrincipalPayment: objList?.graceOnPrincipalPayment,
                    graceOnInterestPayment: objList?.graceOnInterestPayment,
                    graceOnArrearsAgeing: objList?.graceOnArrearsAgeing,
                    nominalInterestRateFrequency: objList?.interestRateFrequencyType?.value,
                    submittedOnDate: dayjs(),
                    startDate: BOM.DateTime(objList?.calendarOptions[0]?.startDate, "only-date"),
                    repeatsOn: objList?.calendarOptions[0]?.humanReadable
                });
                setIsProductSelected(true);
                setIsLoading(false);
            }
        });
    };

    const getCollateralTemplate = (productParam) => {

        setIsLoading(true);
        const params = {
            fields: "id,loanCollateralOptions",
            productId: productParam,
            templateType: "collateral"
        };
        const url = `${apiConfig.Loans}/template`;

        let body = {
            session,
            params,
        };

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objList = res;

                setIsLoading(false);
            }
        });
    };

    const onChange = (value) => {
        setCurrent(value);
    };

    const onFinishDetailsForm = (values) => {
        values.submittedOnDate = values.submittedOnDate
            ? BOM.DateTime(values.submittedOnDate, "only-date")
            : values.submittedOnDate;

        values.expectedDisbursementDate = values.expectedDisbursementDate
            ? BOM.DateTime(values.expectedDisbursementDate, "only-date")
            : values.expectedDisbursementDate;

        setFormData({ ...formData, details: values });
        setCurrent(current + 1);
    };

    const onFinishTermsForm = (values) => {
        values.repaymentsStartingFromDate = values.repaymentsStartingFromDate
            ? BOM.DateTime(values.repaymentsStartingFromDate, "only-date")
            : values.repaymentsStartingFromDate;

        values.interestChargedFromDate = values.interestChargedFromDate
            ? BOM.DateTime(values.interestChargedFromDate, "only-date")
            : values.interestChargedFromDate;

        setFormData({ ...formData, terms: values });

        values.allowPartialPeriodInterestCalcualtion =
            allowPartialPeriodInterestCalcualtion;
        values.isEqualAmortization = isEqualAmortization;
        values.disbursementData = disbursementDataList;
        values.rates = [];

        setCurrent(current + 1);
    };

    const onFinishChargeForm = (values) => {
        let tempChargeArray = [];
        let tempCollateralArray = [];
        chargeTableSource.forEach((element, index) => {
            if (element.feeOnMonthDay === "-") {
                tempChargeArray.push({
                    chargeId: element.id,
                    amount: element.amountToUse,
                });
            } else {
                tempChargeArray.push({
                    chargeId: element.id,
                    amount: element.amountToUse,
                    feeOnMonthDay: BOM.DateTimeWithoutYear(
                        element.feeOnMonthDay,
                        "only-date"
                    ),
                });
            }
        });
        collateralTableSource.forEach((element, index) => {
            tempCollateralArray.push({
                collateral: element.id,
                quantity: element.value,
            });
        });

        values.charges = tempChargeArray;
        values.collateral = tempCollateralArray;

        delete values.chargeId;

        setFormData({
            ...formData,
            charges: values.charges,
            collateral: values.collateral,
        });
        setCurrent(current + 1);
    };


    const getProductTemplate = (customerParam) => {

        const params = {
            activeOnly: true,
            groupId: `${state.id}`,
            staffInSelectedOfficeOnly: true,
            templateType: "group"
        }

        const url = `${apiConfig.Loans}/template`;

        let body = {
            session,
            params,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            } else {
                const objDetail = res;
                let tempProducts = [];

                objDetail?.productOptions?.forEach((element) => {
                    tempProducts.push({
                        value: element.id,
                        label: element.name ? `${element.name} (${element.id})` : "",
                    });
                });

                setProductOptions(tempProducts);
                setGroupInfo(customerParam);
                setIsLoading(false);
            }
        });
    };

    const onChangeProduct = (productParam) => {
        setIsStepDisabled(false);
        setShowDetailsForm(true);
        getGroupTemplate(productParam)
        getCollateralTemplate(productParam)
    };

    const handleAllowPartialPeriodInterestCalcualtion = (e) => {
        setAllowPartialPeriodInterestCalcualtion(e.target.checked);
    };

    const handleIsEqualAmortization = (e) => {
        setIsEqualAmortization(e.target.checked);
    };

    const handleLoanType = (valueParam) => {
        return productTemplate.hasOwnProperty("clientId") &&
            productTemplate.hasOwnProperty("group")
            ? (valueParam.loanType = "jlg")
            : productTemplate.hasOwnProperty("clientId")
                ? (valueParam.loanType = "individual")
                : productTemplate.hasOwnProperty("group")
                    ? (valueParam.loanType = "group")
                    : null;
    };

    const forms = [
        <DetailForm
            showDetailsForm={showDetailsForm}
            onFinish={onFinishDetailsForm}
            form={useForm}
            initialValues={formData.details}
            onChangeProduct={onChangeProduct}
            productOptions={productOptions}
            loanOfficerOptions={loanOfficerOptions}
            loanPurposeOptions={loanPurposeOptions}
            fundOptions={fundOptions}
            accountLinkingOptions={accountLinkingOptions}
        />,

        <TermsForm
            onFinish={onFinishTermsForm}
            form={useForm}
            formData={formData.terms}
            termFrequencyTypeOptions={termFrequencyTypeOptions}
            repaymentFrequencyTypeOptions={repaymentFrequencyTypeOptions}
            repaymentFrequencyNthDayTypeOptions={repaymentFrequencyNthDayTypeOptions}
            repaymentFrequencyDaysOfWeekTypeOptions={repaymentFrequencyDaysOfWeekTypeOptions}
            interestTypeOptions={interestTypeOptions}
            amortizationTypeOptions={amortizationTypeOptions}
            interestCalculationPeriodTypeOptions={interestCalculationPeriodTypeOptions}
            transactionProcessingStrategyOptions={transactionProcessingStrategyOptions}
            loanAccountDetails={loanAccountDetails}
            allowPartialPeriodInterestCalcualtion={allowPartialPeriodInterestCalcualtion}
            handleAllowPartialPeriodInterestCalcualtion={handleAllowPartialPeriodInterestCalcualtion}
            handleIsEqualAmortization={handleIsEqualAmortization}
            isEqualAmortization={isEqualAmortization}
            productTemplate={productTemplate}
            disbursementDataList={disbursementDataList}
            setDisbursementDataList={setDisbursementDataList}
        />,

        <ChargesForm
            form={useForm}
            onFinish={onFinishChargeForm}
            chargesOptions={chargeOptions}
            userData={userData}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            chargeTableSource={chargeTableSource}
            setChargeTableSource={setChargeTableSource}
            loanCollateralOptions={loanCollateralOptions}
            collateralTableSource={collateralTableSource}
            setCollateralTableSource={setCollateralTableSource}
            setChargesValue={setChargesValue}
            penaltyTableSource={penaltyTableSource}
        />,

        <Preview
            formData={formData}
            loanAccountDetails={loanAccountDetails}
            productTemplate={productTemplate}
            chargeTableSource={chargeTableSource}
            collateralTableSource={collateralTableSource}
        />,
    ];

    const isLastStep = current === forms.length - 1;

    const nextButtonClick = () => {
        if (!isStepDisabled) {
            useForm.submit();
        } else {
            return null;
        }
    };

    const prevButtonClick = () => {
        setCurrent(current - 1);
    };

    function onCancel() {
        navigate("/detail-group", { state: state });
    }

    const onSubmit = (formValues) => {
        formValues = {
            ...formData.details,
            ...formData.terms,
        };

        // STRICT VALUES
        formValues.charges = formData.charges;
        formValues.collateral = formData.collateral;
        formValues.groupId = productTemplate?.group?.id;

        handleLoanType(formValues);

        delete formValues.daysInMonth;
        delete formValues.daysinYear;
        delete formValues.interestRecalculationCompounding;
        delete formValues.FrequencyForRecalculate;
        delete formValues.advancePayments;
        delete formValues.customerSearch;
        delete formValues.isInterestRecalculationEnabled;
        delete formValues.recalculationCompoundingFrequency;
        delete formValues.nominalInterestRateFrequency;
        delete formValues.startDate;
        delete formValues.repeatsOn;

        const body = {
            ...formValues,
            locale: "en",
            dateFormat: "dd MMMM yyyy",
            method: "POST",
            session,
        };

        setIsLoading(true);
        // return
        BOM.FetchReqAction(body, apiConfig.Loans, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.newLoanApplicationMsg);
                navigate("/detail-group-loan", { state: { id: res.resourceId } });

                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
            <TopContent
                pageTitle={labelConfig.newLoanApplication}
                pageItems={staticConfig.newLoanApplicationBreadcrumbItems}
            />
            <Spin spinning={isLoading} size="large">
                <Card
                    title={labelConfig.loanApplicationSetup}
                    style={styles.cardWrapper}
                >
                    <div>
                        <Row
                            gutter={{
                                xs: 8,
                                sm: 16,
                                md: 24,
                                lg: 32,
                            }}
                            style={{ marginBottom: 25 }}
                        >
                            <Col span={24}>
                                <Row style={{ justifyContent: "space-between" }}>
                                    {/* Navigation section */}
                                    <Card style={styles.cardSteps}>
                                        <Steps
                                            current={current}
                                            onChange={onChange}
                                            direction="vertical"
                                            style={{ height: "600px" }}
                                            items={[
                                                {
                                                    title: <Text strong>{labelConfig.details}</Text>,
                                                },

                                                {
                                                    title: <Text strong>{labelConfig.terms}</Text>,
                                                    // disabled: isStepDisabled,
                                                },

                                                {
                                                    title: <Text strong>{labelConfig.charges}</Text>,
                                                    // disabled: isStepDisabled,
                                                },

                                                {
                                                    title: <Text strong>{labelConfig.preview}</Text>,
                                                    // disabled: isStepDisabled,
                                                },
                                            ]}
                                        />
                                    </Card>
                                    {/* Form Section */}
                                    <Card style={styles.cardStepDisplay}>
                                        <div>{forms[current]}</div>
                                    </Card>
                                </Row>
                            </Col>
                        </Row>

                        {/* Submitt section */}
                        <Card
                            style={{
                                marginBottom: 25,
                                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                                borderRadius: 20,
                                padding: 5,
                            }}
                        >
                            <Flex
                                justify="space-between"
                                style={{ paddingLeft: "20px", paddingRight: "40px" }}
                            >
                                {current === 0 && (
                                    <Button
                                        style={{
                                            width: "12%",
                                            height: "15%",
                                            backgroundColor: "white",
                                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                            borderRadius: 20,
                                            color: "black",
                                        }}
                                        onClick={onCancel}
                                    >
                                        Cancel
                                    </Button>
                                )}
                                {current > 0 && (
                                    <Button
                                        style={{
                                            width: "10%",
                                            height: "15%",
                                            backgroundColor: "#92428B",
                                            color: "white",
                                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                            borderRadius: 20,
                                        }}
                                        onClick={prevButtonClick}
                                    >
                                        Prev
                                    </Button>
                                )}
                                {!isLastStep && (
                                    <Button
                                        style={{
                                            width: "10%",
                                            height: "15%",
                                            backgroundColor: "#92428B",
                                            color: "white",
                                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                            borderRadius: 20,
                                        }}
                                        onClick={nextButtonClick}
                                    >
                                        Next
                                    </Button>
                                )}
                                {isLastStep && (
                                    BOM.HasPermission("CREATE_LOAN") &&
                                    <CustomButton
                                        content="Submit"
                                        style={{
                                            width: "10%",
                                            marginLeft: "auto",
                                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                        }}
                                        onClick={onSubmit}
                                        backgroundColor="#fff"
                                        colorText="black"
                                        hoverBackground="#F5F5F5"
                                    />
                                )}
                            </Flex>
                        </Card>
                    </div>
                </Card>
            </Spin>
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
    rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GroupLoanApplication);
